import { API_BASE } from './config';

export { UPLOADS_BASE } from './config';

async function fetchJson(url) {
  const response = await fetch(url);
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || `Request failed (${response.status})`);
  }
  const data = await response.json();
  return data;
}

export const slugifyEstablishmentName = (text, id) => {
  const base = String(text || 'hospital')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
  return base ? `${base}-${id}` : `hospital-${id}`;
};

export function getEstablishmentIdFromSlug(slug) {
  const raw = String(slug || '');
  if (/^\d+$/.test(raw)) return Number(raw);
  const match = raw.match(/-(\d+)$/);
  return match ? Number(match[1]) : null;
}

export async function fetchEstablishments() {
  const data = await fetchJson(`${API_BASE}/master/establishments`);
  return Array.isArray(data) ? data : [];
}

export async function fetchEstablishmentById(id) {
  return fetchJson(`${API_BASE}/master/establishments/${id}`);
}

export async function fetchAccreditations() {
  const data = await fetchJson(`${API_BASE}/master/accreditations`);
  return Array.isArray(data) ? data : [];
}

export async function fetchLocations() {
  const data = await fetchJson(`${API_BASE}/locations`);
  return Array.isArray(data) ? data : [];
}

export async function fetchLocationTypes() {
  const data = await fetchJson(`${API_BASE}/locations/types`);
  return Array.isArray(data) ? data : [];
}

export async function fetchLocationsByParent(parentId) {
  if (!parentId) return [];
  const data = await fetchJson(`${API_BASE}/locations?parent_id=${encodeURIComponent(parentId)}`);
  return Array.isArray(data) ? data : [];
}
